// extracted by mini-css-extract-plugin
export default {"div-user-menu-item":"styles_div-user-menu-item__v3C13"};